import AddToCompare from './AddToCompare'

export default AddToCompare
